import React from "react";
import { BASE_IMAGE_URL } from "../utils/api";
import "../styles/SavedCars.css";
import "../styles/SavedCars.mobile.css";
import useSavedCarsController from "../controllers/useSavedCarsController";

export default function SavedCarsSection({ setCurrentView, onAddCar }) {
  const {
    cars,
    loading,
    error,
    deletingId,
    goAddCar,
    handleDelete,
    openInBrands,
    hintLogin,
  } = useSavedCarsController({ setCurrentView, onAddCar });

  return (
    <section className="saved-cars" dir="rtl">
      <div className="clip-bg"></div>
      <h1 className="saved-cars__title">سياراتي المحفوظة</h1>

      {loading && <div className="saved-cars__state">جاري التحميل...</div>}
      {!loading && error && <div className="saved-cars__state error">{error}</div>}

      {!loading && cars.length === 0 && (
        <div className="saved-cars__empty">
          {hintLogin && (
            <a
              href=""
              onClick={(e) => { e.preventDefault(); setCurrentView?.("login"); }}
              style={{ color: "#CAEA3E", textDecoration: "underline", cursor: "pointer" }}
            >
              سجّل دخول عشان تقدر تضيف سياراتك
            </a>
          )}
          {!hintLogin && (
            <div className="saved-cars__hint">
              لا توجد سيارات محفوظة حالياً.
            </div>
          )}
        </div>
      )}
      

      {!loading && cars.length > 0 && (
        <div className="saved-cars__list">
          {cars.map((car) => {
            const id = car.id;
            const name = car.name || "—";
            const year = car.year_id ? String(car.year.year) : "—";
            const model = car.year_id ? String(car.year.model.name) : "—";
            const brand = car.year_id ? String(car.year.model.brand.name) : "—";
            const img =
              typeof car.year?.model?.brand?.image === "string"
                ? (car.year.model.brand.image.startsWith("http")
                  ? car.year.model.brand.image
                  : `${BASE_IMAGE_URL}${car.year.model.brand.image}`)
                : "/src/assets/images/default.jpg";

            return (
              <article
                key={id}
                className="saved-cars__card"
                onClick={() => openInBrands(car)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && openInBrands(car)}
                style={{ cursor: "pointer" }}
              >
                <button
                  type="button"
                  className="saved-cars__delete"
                  onClick={(e) => {        // ⬅️ stop bubbling to the article
                    e.stopPropagation();
                    handleDelete(id);
                  }}
                  onPointerDown={(e) => e.stopPropagation()} // ⬅️ prevents early bubbling on touch
                  onKeyDown={(e) => {       // ⬅️ if user presses Enter/Space on the delete button
                    e.stopPropagation();
                    if (e.key === "Enter" || e.key === " ") handleDelete(id);
                  }}
                  disabled={deletingId === id}
                  aria-label="حذف السيارة من المحفوظة"
                  title="حذف"
                >
                  {/* trash icon */}
                  <svg width="58" height="48" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m2 0-1.2 14.4A2 2 0 0 1 15.8 22H8.2a 2 2 0 0 1-1.99-1.6L5 6"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>

                <div className="saved-cars__card-inner">
                  <div className="saved-cars__specs">
                    <div className="saved-cars__thumb">
                      {img ? (
                        <img src={img} alt={name} />
                      ) : (
                        <div className="saved-cars__noimg">لا توجد صورة</div>
                      )}
                    </div>

                    <div className="spec-col">
                      <div className="spec-row">
                        <span className="spec-k">نوع السيارة:</span>
                        <span className="spec-v">{brand}</span>
                      </div>
                      <div className="spec-row">
                        <span className="spec-k">الموديل:</span>
                        <span className="spec-v">{model}</span>
                      </div>
                    </div>

                    <div className="spec-col">
                      <div className="spec-row">
                        <span className="spec-k">سنة الصنع:</span>
                        <span className="spec-v">{year}</span>
                      </div>
                      <div className="spec-row">
                        <span className="spec-k">فئة السيارة:</span>
                        <span className="spec-v">{name}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      )}

      
          <button
            type="button"
            className={`saved-cars__add ${hintLogin ? "is-disabled" : ""}`}
            onClick={goAddCar}
            disabled={hintLogin}
            aria-label="إضافة سيارة"
            title={hintLogin ? "سجّل الدخول لإضافة سياراتك" : "إضافة سيارة"}
          >
            +
          </button>
    </section>
  );
}
